import { type AgreementStatus, AgreementStatusValues } from '@inpart-io/padme-iap';

import { AGREEMENT_PREFIX } from '@/constants/router-prefixes.constants';
import { ICONS_NAME } from '@/constants/ui/icons.constants';

export const IN_PART = 'in-part';

export interface AgreementStatusOption {
    key: AgreementStatus;
    label: string;
    value: AgreementStatus;
}

export const AgreementStatusIcon: Record<AgreementStatus, string> = {
    [AgreementStatusValues.DRAFT]: ICONS_NAME.EDIT_SOLID,
    [AgreementStatusValues.ABORTED]: ICONS_NAME.TIMES_CIRCLE_SOLID,
    [AgreementStatusValues.ACTIVE]: ICONS_NAME.PLAY_CIRCLE_SOLID,
    [AgreementStatusValues.TERMINATED]: ICONS_NAME.TERMINATED_ICON,
    [AgreementStatusValues.EXPIRED]: ICONS_NAME.TIMES_CIRCLE_SOLID
};

export const AgreementStatusColorClass: Record<AgreementStatus, string> = {
    [AgreementStatusValues.DRAFT]: 'on-hold',
    [AgreementStatusValues.ABORTED]: 'grey-darker',
    [AgreementStatusValues.ACTIVE]: 'active',
    [AgreementStatusValues.TERMINATED]: 'grey-darker',
    [AgreementStatusValues.EXPIRED]: 'disqualified'
};

export const AgreementListMode = {
    ALLIANCE: 'agreement.alliance',
    LEAD: 'agreement.lead',
    COMPANY: 'agreement.company',
    HUB: 'agreement.hub'
} as const;

export type IAgreementListMode = (typeof AgreementListMode)[keyof typeof AgreementListMode];

export const FILTERS = {
    ID: 'agreementId',
    NAME_SEARCH_TEXT: 'agreementSearchText',
    ALLIANCE: 'alliances',
    COMPANY: 'companies',
    LEAD: 'leads',
    TYPE: 'type',
    STATUS: 'status',
    OWNER: 'owner',
    TERRITORIES: 'territories',
    EFFECTIVE_DATE_BEGIN: 'effectiveDateBegin',
    EFFECTIVE_DATE_END: 'effectiveDateEnd',
    EXPIRATION_DATE_BEGIN: 'expirationDateBegin',
    EXPIRATION_DATE_END: 'expirationDateEnd',
    CREATED_BY: 'createdBy',
    MODIFIED_BY: 'modifiedBy',
    CREATED_ON_BEGIN: 'createdOnBegin',
    CREATED_ON_END: 'createdOnEnd',
    MODIFIED_ON_BEGIN: 'modifiedOnBegin',
    MODIFIED_ON_END: 'modifiedOnEnd',
    AUTHORIZED: 'authorizedOnly',
    RELATED_COMPANIES: 'relatedCompanies',
    COUNTRIES: 'countries',
    COMPANY_TYPES: 'companyTypes'
} as const;

export const AGREEMENT_ID_REGEX = new RegExp(`${AGREEMENT_PREFIX}-\\d+`);
